/**
 * Botão flutuante do Indique e Ganhe (Member Get Member).
 *
 * O admin gera a URL; ninguém digita. O app (new-wallet) abre o link no
 * webview e, com `shouldShow: true`, anexa o `profile.uniqueId` do cliente ao
 * FIM da URL. Por isso a URL termina em `#u=`: o CPF vai no fragment — nunca
 * chega a servidor, log de acesso nem Referer. A página lê e apaga na hora.
 */

export const MGM_FAB_DEFAULT_LABEL = 'Indique e ganhe';

/** Origem da página pública do MGM: env de build, senão a própria origem do admin. */
export function mgmPublicOrigin(): string {
  const configured = import.meta.env.VITE_MGM_PUBLIC_ORIGIN;
  if (configured) return configured.replace(/\/+$/, '');
  return typeof window !== 'undefined' ? window.location.origin : '';
}

export function buildMgmFabUrl(idPassbook: string, origin: string = mgmPublicOrigin()): string {
  return `${origin.replace(/\/+$/, '')}/mgm/${idPassbook}#u=`;
}

/**
 * Versão curta do link para exibir na prévia: sem protocolo e com o id do
 * passbook encurtado no meio. O botão de copiar usa sempre o link inteiro.
 */
export function displayMgmFabUrl(url: string): string {
  return url
    .replace(/^https?:\/\//i, '')
    .replace(/\/mgm\/([a-f0-9]{6})[a-f0-9]{14}([a-f0-9]{4})/i, '/mgm/$1…$2');
}

/** Ícone padrão (presente), no mesmo traço do ícone padrão dos FABs. */
export function mgmFabIconSvg(): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="8" width="18" height="4" rx="1" stroke="currentColor" stroke-width="2"/>
    <path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <path d="M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 0 1 0 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;
}
